<template>
  <div class="mb-1 infor-card-container" :class="{ warning, alert, normal }">
    <div
      v-if="title"
      class="fs-6 fw-medium px-3 text-right"
      v-html="title"
      @click="$emit('click')"
    />
    <hr v-if="title" class="my-2" :class="{ warning, alert, normal }" />
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";

export default defineComponent({
  name: "InfoCard",
  props: {
    title: {
      type: String,
      default: "",
    },
    style: {
      type: String,
      default: "normal",
    },
  },
  emits: ["click"],
  setup(_) {
    const warning = ref<boolean>(false);
    const alert = ref<boolean>(false);
    const normal = ref<boolean>(false);
    onMounted(() => {
      switch (_.style) {
        case "alert":
          alert.value = true;
          break;
        case "warning":
          warning.value = true;
          break;
        default:
          normal.value = true;
          break;
      }
    });
    return {
      warning,
      alert,
      normal,
    };
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
$positive-green: #d5efd4;
$positive-green-dark: #aed3ad;
$alert-red: #ffe4e6;
$normal-grey: #f2f2f2;
$normal-grey-border: #dddddd;
$warning-yellow: #fff1c2;
$warning-yellow-border: #f5cd47;
.infor-card-container {
  display: flex;
  flex-direction: column;
  padding: 18px 15px;
  gap: 9px;
  border-radius: 10px;
  border: 1px solid $positive-green-dark;
  background-color: $positive-green;
}
.alert {
  color: $pj-color-red;
  background-color: $alert-red;
  border: none;
}
.warning {
  color: black;
  background-color: $warning-yellow;
  border: 1px solid $warning-yellow-border;
}
.normal {
  color: #007c3b;
  background-color: $normal-grey;
  border: 1px solid $normal-grey-border;
}
.fw-medium {
  font-weight: 600 !important;
}
.bottom-border {
  border: 1px solid;
}
</style>
